<template>
  <div :class="$style.basePlan" class="h-100">
    <router-link :to="{ name: 'contact' }" class="h-100 basePlan__Inner d-flex flex-column text-decoration-none color-text-1">
      <div class="plan-img">
        <img :src="img" alt="" />
        <p class="plan-img__tag">{{ text }}</p>
      </div>
      <div class="content-wrapper">
        <h3 class="basePlan__title">{{ title }}</h3>
        <div class="basePlan__money">
          <span class="money font-josefin">{{ money.money }}</span
          ><span v-if="money.count" class="count ml-2">{{ money.count }}</span></div
        >
        <ul class="basePlan__list list-unstyled">
          <template v-if="list.length">
            <li v-for="(item, $index) in list" :key="$index" class="basePlan__item d-flex">
              <!-- <i class="icon icomoon icon-check"></i> -->
              <img style="margin-right: 8px;" src="@assets/images/home/icon-check.svg" alt="" />
              <span v-html="item"></span>
            </li>
          </template>
          <template v-if="starList.length">
            <li v-for="(item, $index2) in starList" :key="`starList-${$index2}`" class="basePlan__item d-flex">
              <i class="fas fa-star color-primary fa-sm pr-1" style="position: relative; top: 4px;"></i>
              <span v-html="item"></span>
            </li>
          </template>
        </ul>
        <div class="basePlan__link">
          <!-- <router-link :to="{ name: 'contact' }" class="dingbeauty-btn is-full is-outline  mb-4">詳細內容</router-link> -->
          <router-link :to="{ path: '/', hash: 'sectionContact' }" class="dingbeauty-btn is-full  mb-4">
            <img class="email-icon" src="@src/assets/dingbeauty-images/contact/icon_mail_white.svg" alt="" />專人聯繫</router-link
          >
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    money: {
      type: Object,
      default: () => {
        return {}
      },
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    starList: {
      type: Array,
      default: () => {
        return []
      },
    },
    to: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isShowContact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  mounted() {
    console.log(this.img)
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.basePlan {
  :global {
    .basePlan__list {
      min-height: 500px;
    }

    .content-wrapper {
      padding: 1.5rem;
    }

    .plan-img {
      position: relative;

      .plan-img__tag {
        font-size: 18px;
        line-height: 1;
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: $color-primary;
        color: #fff;
        opacity: 0.8;
        margin: 0;
        padding: 0.5rem 1rem;
      }
    }

    .basePlan {
      &__Inner {
        background: #ffffff;
        border: 2px solid #edf0f4;
        transition: 0.3s;

        &:hover {
          transform: translateY(-15px);
          border: 2px solid $color-primary;
        }
      }
      &__title {
        font-size: 20px;
        font-weight: 600;
        color: $color-text-1;
        @include max-md {
          font-size: 16px;
        }
      }
      &__money {
        color: #777777;
        .money {
          font-size: 1.9rem;
          color: $color-text-1;
          // margin-right: 14px;
          @include max-md {
            font-size: 1.5rem;
          }
        }
        .count {
          padding-top: 10px;
          @include max-md {
            font-size: 14px;
          }
        }
      }
      &__img {
        position: relative;
        top: -70px;
      }
      &__list {
        margin-top: 24px;
        margin-bottom: 30px;
        padding-top: 30px;
        border-top: 1px solid $color-line;
      }
      &__item {
        color: $color-text-2;
        @include max-md {
          font-size: 14px;
        }
        &:not(:first-child) {
          margin-top: 16px;
        }
        .icon {
          font-size: 14px;
          color: $color-primary;
          padding-top: 7px;
          padding-right: 5px;
        }
      }
      &__link {
        margin-top: auto;
      }
    }
  }
}

@media (min-width: 1200px) {
  .basePlan {
    :global {
      .plan-img {
        .plan-img__tag {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
